<template>
  <Accordion v-if="hasVisibleOptions" :defaultOpen="props.accordionDefaultOpen">
    <template #header>
      <p class="accent">{{ t('label_option_settings') }}</p>
    </template>
    <template #default>
      <div v-if="visibleOptions.includes('showGuestMic')" class="flex-btw opt-item">
        {{ t('label_allow_guest_microphone') }}
        <ToggleSwitch v-model="form.options.showGuestMic" />
      </div>

      <div v-if="visibleOptions.includes('showAttendee')" class="flex-btw opt-item">
        {{ t('label_show_attendee_list_messages') }}
        <ToggleSwitch v-model="form.options.showAttendee" />
      </div>

      <div v-if="visibleOptions.includes('displayVoiceRegister')" class="flex-btw opt-item">
        {{ t('label_show_voice_registration_on_connect') }}
        <ToggleSwitch v-model="form.options.displayVoiceRegister" />
      </div>

      <div v-if="visibleOptions.includes('screenMode')" class="flex-btw opt-item">
        {{ t('label_provide_screen_mode') }}
        <ToggleSwitch v-model="form.options.screenMode" />
      </div>
      <div v-if="visibleOptions.includes('subtitleMode')" class="flex-btw opt-item">
        {{ t('label_provide_subtitle_mode') }}
        <ToggleSwitch v-model="form.options.subtitleMode" />
      </div>
      <div v-if="visibleOptions.includes('useWithoutHost')" class="flex-btw opt-item">
        {{ t('label_provide_without_host') }}
        <ToggleSwitch v-model="form.options.useWithoutHost" />
      </div>
    </template>
  </Accordion>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Accordion from '@/components/shared/base/Accordion.vue';
import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import { ChatCreateForm } from '@/types/components';
import { DEFAULT_CHAT_CREATE_FORM, CHAT_VISIBLE_OPTION_PRESETS, getChatModeKeyById } from '@/utils/constants/chat';

const { t } = useI18n();

const form = defineModel<ChatCreateForm>('form', {
  default: DEFAULT_CHAT_CREATE_FORM,
});

const props = defineProps({
  accordionDefaultOpen: Boolean,
});

const visibleOptions = computed<string[]>(() => {
  const modeKey = getChatModeKeyById(form.value.id);
  return CHAT_VISIBLE_OPTION_PRESETS[modeKey] || [];
});

const hasVisibleOptions = computed<boolean>(() => {
  return visibleOptions.value.length > 0;
});
</script>

<style lang="scss" scoped></style>
